<template>
    <div class="">
        <div class="form-group kt-margin-0 kt-padding-0 w-100">
            <div class="row">
                <div class="col col-sm-12">
                    <v-select v-model="paymentPeriodType"
                              :class="addBtn?'vselect-with-btn': ''"
                              label="displayName"
                              :options="groups"
                              :filterable="false"
                              :placeholder="placeholder"
                              @search="onGroupSearch"
                              @search:focus="onGroupFocus"
                              @input="onGroupChange">
                        <template slot="option" slot-scope="option" v-if="option">
                            <div v-html="option.displayName"></div>
                        </template>
                        <span slot="no-options">
                                {{$t("empty")}}
                            </span>
                    </v-select>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import initFilterModel from '@/shared/filter';

    export default {
        name: "FixedExpensePaymentPeriodTypeSelect",
        components: {

        },
        props: {
            placeholder: String,
            type: String,
            addBtn: {
                type: Boolean,
                default: false
            },
            value: Object,
            parent: Object,
        },
        data() {
            return {
                filter: initFilterModel(),
                paymentPeriodType: null,
                groups: [],
                loading: false,
            }
        },
        methods: {
            getData() {
                const headers = {
                    'lang': localStorage.getItem('x_lang')
                };
                this.$http.get('fixed-expense/payment-period-type', {headers})
                    .then(res => {
                        this.loading = false;
                        console.log(res.data);
                        this.groups = res.data.data;
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            onGroupSearch(searchTxt) {
                this.loading = true;
                this.groups = [];
                this.filter.search = searchTxt;
                this.getData();
            },
            onGroupFocus() {
                this.loading = true;
                this.groups = [];
                this.filter.search = null;
                this.getData();
            },
            onGroupChange() {
                this.$emit('input', this.paymentPeriodType);
            },

        },
        created() {

        },
        mounted() {
            // console.log(this.parentData);
            setTimeout(() => {
                console.log(this.$props.value);
                if (this.$props.value) {
                    this.paymentPeriodType = this.$props.value;
                }
            }, 1000);

        },
    }
</script>

<style scoped>

</style>